import { configureStore, type Middleware } from '@reduxjs/toolkit';

import rootReducer from 'stash/reducers';
import { createMiddlewareArray } from 'stash/middleware';
import { init } from 'stash/actions/init';
import { hydrateStateFromCookies } from './hydrate';

interface CreateStoreOptions {
	analytics: unknown;
}

export const createStore = ({ analytics }: CreateStoreOptions) => {
	const customMiddleware = createMiddlewareArray({ analytics }) as Middleware[];

	const store = configureStore({
		reducer: rootReducer,
		preloadedState: hydrateStateFromCookies(),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false,
				immutableCheck: false,
			}).concat(customMiddleware),
	});

	store.dispatch(init());

	return store;
};
